import { CSSProperties, FunctionComponent } from 'react';
import { ImageTextOverlay } from '../../core/formBuilder/usePages';
import { getTransformForTextOverlayContent } from '../@material/textArea/textAreaUtils';
import parse from 'html-react-parser';
import { useBuzzwordReplacement } from '../util/hooks/internal/buzzWords/useBuzzwordReplacement';

interface ImageTextOverlayComponentProps {
  textOverlay?: ImageTextOverlay | null;
  skipManualTransform?: boolean;
  styles?: CSSProperties;
}

const ImageTextOverlayComponent: FunctionComponent<
  ImageTextOverlayComponentProps
> = ({ textOverlay, skipManualTransform = false, styles }) => {
  const resolvedContent = useBuzzwordReplacement(textOverlay?.content);

  if (
    !textOverlay ||
    !textOverlay.checked ||
    !textOverlay.content?.trim() ||
    !resolvedContent?.trim()
  )
    return null;

  const top = textOverlay.offsetY ?? 0;
  const left = textOverlay.offsetX ?? 0;

  const transform = skipManualTransform
    ? undefined
    : getTransformForTextOverlayContent(textOverlay.content, top, left);

  return (
    <div
      style={{
        position: 'absolute',
        top: `${top}%`,
        left: `${left}%`,
        transform: `${transform}`,
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        zIndex: 10,
        ...styles,
      }}
    >
      {parse(resolvedContent)}
    </div>
  );
};

export default ImageTextOverlayComponent;
